import { z } from 'zod'

/** Same tool/params/result convention as bug evidence; the model supplies only the call and claim. */
export const RepairCitationSchema = z.object({
  tool: z.string().min(1),
  params: z.record(z.unknown()),
  finding: z.string().trim().min(1).max(8000).describe('Observed facts supporting the problem or repair; distinguish inference and identify the relevant request, step, or point.'),
}).strict()
const ResolvedCitationSchema = RepairCitationSchema.extend({
  result: z.string().min(1), script_resolved: z.literal(true),
})
// Historical candidates used temporary references. Keep them readable, never offer them to the model.
export const RepairEvidenceSchema = z.union([ResolvedCitationSchema, z.object({
  source: z.enum(['browser', 'driver', 'capture']), reference: z.string().min(1).max(8000),
  finding: z.string().min(1).max(8000),
}).strict()])
